import React from "react";

export const _02ATitle: React.FC = (): JSX.Element => {
  return (
    <div id="about" className="flex w-full justify-center items-center scroll-mt-[100px]">
      <div className="flex flex-wrap w-[1440px] h-[591px] items-center justify-center gap-[0px_0px] relative bg-white">
        <div className="flex flex-col min-h-[591px] items-center justify-center pt-[60px] pb-[30px] px-[170px] relative flex-1 grow">
          <div className="flex flex-col items-center justify-center gap-[50px] relative self-stretch w-full flex-[0_0_auto]">
            <div className="flex w-[118px] h-[118px] items-center justify-center gap-2.5 p-2 relative bg-[var(--fy-blueish)] rounded-[59px]">
              <img
                className="relative w-[106px] h-[106px] mt-[-2.00px] mb-[-2.00px] ml-[-2.00px] mr-[-2.00px] object-cover"
                alt="Icon photo"
                src="/img/iconphoto.svg"
              />
            </div>

            <div className="flex flex-col items-center justify-center relative self-stretch w-full flex-[0_0_auto]">
              <div className="relative self-stretch mt-[-1.00px] font-section-title font-[number:var(--section-title-font-weight)] text-[var(--fy-grey)] text-[length:var(--section-title-font-size)] text-center tracking-[var(--section-title-letter-spacing)] leading-[var(--section-title-line-height)] [font-style:var(--section-title-font-style)]">
                Split Payments Monthly
              </div>
            </div>

            <div className="flex flex-col items-center justify-center relative self-stretch w-full flex-[0_0_auto]">
              <p className="relative self-stretch mt-[-1.00px] font-section-description font-[number:var(--section-description-font-weight)] text-[var(--fy-grey)] text-[length:var(--section-description-font-size)] text-center tracking-[var(--section-description-letter-spacing)] leading-[var(--section-description-line-height)] [font-style:var(--section-description-font-style)]">
                We&#39;re Chris &amp; Sarah, a married couple with 10 years
                experience. 
                <br />
                Don&#39;t let your budget stop your lifetime memory. Pay <br />
                what you can afford, however you can afford it.
              </p>
            </div>

            <div className="flex flex-col h-[28.89px] items-center justify-center relative self-stretch w-full">
              <div className="relative self-stretch mt-[-1.06px] font-section-divider font-[number:var(--section-divider-font-weight)] text-[var(--fy-orange)] text-[length:var(--section-divider-font-size)] text-center tracking-[var(--section-divider-letter-spacing)] leading-[var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
                ........................................................................................................................................
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 